<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="添加租凭合同" width="800px" :close-on-click-modal="false" top="1vh" :close-on-press-escape="false">
    <el-form class="add-or-update-form" :model="dataForm" :rules="dataRule" :size="btnSize" ref="dataForm" @keyup.enter.native="submitHandle()" label-position='right' label-width="120px" v-loading="dialogLoading">
      <el-row class="content">
        <el-col :span="6">
          <el-form-item prop="lesseeNature" label="租户性质">
            <el-select v-model="dataForm.lesseeNature" style="width: 100px;" placeholder="">
              <el-option :value="2" label="公司"></el-option>
              <el-option :value="1" label="个人"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item prop="lesseeId" label="租户id">
            <el-input v-model.trim="dataForm.lesseeId" placeholder="" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item prop="lesseeTransactorId" label="租户办理人id">
            <el-input v-model.trim="dataForm.lesseeTransactorId" placeholder="" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="startTime" label="合同时间">
            <el-date-picker
              style="width: 160px;"
              v-model="dataForm.startTime"
              type="date"
              placeholder="">
            </el-date-picker>
            -
            <el-date-picker
              style="width: 160px;"
              v-model="dataForm.endTime"
              type="date"
              placeholder="">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <h3 class="title">租用场地</h3>
          <el-table ref="table" class="simple-table" max-height="200px" :data="siteList" @selection-change="handleSelectionChange" highlight-current-row fit border >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="场地名称" align="left" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="place" label="位置" align="left" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="area" label="面积" align="left" min-width="160" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <h3 class="title">合同能源计价表</h3>
          <div class="border energyPricing" v-for="(energyPricing, key) in dataForm.energyPricing" :key="key">
            <el-button class="delete" type="danger" size="mini" v-if="dataForm.energyPricing.length > 1" @click="handleDeleteItem(dataForm.energyPricing, key)">删除</el-button>
            <el-col :span="12">
              <el-form-item
                :prop="'energyPricing.' + key + '.energyType'"
                :rules="{
                  required: true, message: '不能为空', trigger: 'blur'
                }"
                label="能源类型">
                <el-select v-model="energyPricing.energyType" placeholder="" @change="handleEnergyTypeChange(energyPricing)">
                  <el-option
                    v-for="item in energyTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'energyPricing.' + key + '.model'"
                :rules="{
                  required: true, message: '不能为空', trigger: 'blur'
                }"
                label="计价模型">
                <el-select v-model="energyPricing.model" placeholder="" @change="handleModelChange(energyPricing)">
                  <el-option label="商业" :value="1" v-if="energyPricing.energyType !== 1"></el-option>
                  <el-option label="商业" :value="2" v-if="energyPricing.energyType === 1"></el-option>
                  <el-option label="阶梯" :value="3" v-if="energyPricing.energyType === 1"></el-option>
                  <el-option label="峰平谷尖" :value="1" v-if="energyPricing.energyType === 1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 峰平谷 -->
            <el-col :span="24" v-if="(energyPricing.energyType === 1 && energyPricing.model === 1)">
              <div class="point">
                <div class="point-item" v-for="(point, idx) in energyPricing.point" :key="idx">
                  <div class="item-left">
                    <h4>{{point.name}}期</h4>
                  </div>
                  <div class="item-right">
                    <el-col :span="24">
                      <el-form-item :prop="'energyPricing.' + key + '.point.' + idx + '.price'"
                        :rules="{
                          required: true, message: '不能为空', trigger: 'blur'
                        }"
                        label="价格">
                        <el-input style="width: 120px;" v-model.trim="point.price" placeholder="" clearable></el-input>
                      </el-form-item>
                    </el-col>
                    <div class="time-content">
                      <div class="time-left">时间分段</div>
                      <div class="time-right">
                        <div class="table-content">
                          <div class="startime">开始时间</div>
                          <div class="endtime">结束时间</div>
                        </div>
                        <div class="input-content" v-for="(time, i) in point.time" :key="i">
                          <div class="startime">
                            <el-form-item
                              :prop="'energyPricing.' + key +  '.point.' + idx + '.time.' + i + '.startTime'"
                              :rules="{
                                required: true, message: '不能为空', trigger: 'blur'
                              }"
                              label-width='0px'>
                              <!-- <el-input v-model.trim="time.startime" placeholder="" clearable></el-input> -->
                              <el-time-select
                                v-model="time.startTime"
                                value-format='HH:mm:ss'
                                :picker-options="{
                                  start: '00:00',
                                  step: '01:00',
                                  end: '24:00'
                                }"
                                placeholder="">
                              </el-time-select>
                            </el-form-item>
                          </div>
                          <div class="endtime">
                            <el-form-item
                              :prop="'energyPricing.' + key +  '.point.' + idx + '.time.' + i + '.endTime'"
                              :rules="{
                                required: true, message: '不能为空', trigger: 'blur'
                              }"
                              label-width='0px'>
                              <!-- <el-input v-model.trim="time.endTime" placeholder="" clearable></el-input> -->
                              <el-time-select
                                v-model="time.endTime"
                                value-format='HH:mm:ss'
                                :picker-options="{
                                  start: '00:00',
                                  step: '01:00',
                                  end: '24:00'
                                }"
                                placeholder="">
                              </el-time-select>
                            </el-form-item>
                          </div>
                          <el-button type="danger" size="mini" v-if="point.time.length > 1" @click="handleDeleteItem(point.time, index)">删除</el-button>
                        </div>
                        <div class="add" @click="handleAddTimeRow(point)" >
                          添加行
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <!-- 阶梯 -->
            <el-col :span="24" v-else-if="(energyPricing.energyType === 1 && energyPricing.model === 3)">
              <div class="ladder">
                <div class="ladder-left">
                  <p>价格</p>
                </div>
                <div class="ladder-right">
                  <div class="title-content">
                    <div class="threshold-value">阈值</div>
                    <div class="unit-price">单价</div>
                  </div>
                  <div class="input-content" v-for="(ladder, index) in energyPricing.ladder" :key="index">
                    <div class="threshold-value">
                      <el-form-item
                        :prop="'energyPricing.' + key +  '.ladder.' + index + '.thresholdValue'"
                        :rules="{
                          required: true, message: '不能为空', trigger: 'blur'
                        }"
                        label-width='0px'>
                         ≥ <el-input style="width: 90%" v-model.trim="ladder.thresholdValue" placeholder="" ></el-input>
                      </el-form-item>
                    </div>
                    <div class="unit-price">
                      <el-form-item
                        :prop="'energyPricing.' + key + '.ladder.' + index + '.unitPrice'"
                        :rules="{
                          required: true, message: '不能为空', trigger: 'blur'
                        }"
                        label-width='0px'>
                        <el-input style="width: 90%" v-model.trim="ladder.unitPrice" placeholder="" ></el-input>
                      </el-form-item>
                    </div>
                    <el-button type="danger" size="mini" v-if="energyPricing.ladder.length > 1" @click="handleDeleteItem(energyPricing.ladder, index)">删除</el-button>
                  </div>
                  <div class="add ladder-add" @click="handleAddRow(energyPricing)" >
                    添加行
                  </div>
                </div>
              </div>
            </el-col>
            <!-- 商业价格 -->
            <el-col :span="12" v-else>
              <el-form-item :prop="'energyPricing.' + key + '.unitPrice'"
                :rules="{
                  required: true, message: '不能为空', trigger: 'blur'
                }"
                label="价格">
                <el-input v-model.trim="energyPricing.unitPrice" placeholder="" clearable></el-input>
              </el-form-item>
            </el-col>
          </div>
        </el-col>
        <el-col :span="24" class="btn-content">
          <div class="add" @click="handleAddEnergyPricing">添加能源计价</div>
          <!-- <el-button :size="btnSize" type="primary">添加能源计价</el-button> -->
        </el-col>
        <div class="basic-fee">
          <h3 class="title">
            基本费用
          </h3>
          <div class="basic-fee-right">
            <div class="table-content">
              <div class="name">费用名称</div>
              <div class="fee">费用</div>
            </div>
            <div class="input-content" v-for="(basicCharges, index) in dataForm.basicCharges" :key="index">
              <div class="name">
                <el-form-item :prop="'basicCharges.' + index + '.name'"
                  label-width="0px">
                  <el-input v-model.trim="basicCharges.name" placeholder="" clearable></el-input>
                </el-form-item>
              </div>
              <div class="value">
                <el-form-item :prop="'basicCharges.' + index + '.value'"
                  label-width="0px">
                  <el-input v-model.trim="basicCharges.value" placeholder="" clearable></el-input>
                </el-form-item>
              </div>
              <el-button class="delete" type="danger" size="mini" v-if="dataForm.basicCharges.length > 0" @click="handleDeleteItem(dataForm.basicCharges, index)">删除</el-button>
            </div>
            <div class="add" @click="handleAddBasicCharges">添加行</div>
          </div>
        </div>
        <!-- <el-col :span="12" >
          <el-form-item prop="takePercentageFromProfit" label="利润抽成">
            <el-input style="width: 130px;" v-model.trim="dataForm.takePercentageFromProfit" placeholder="" clearable></el-input>%
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="btnSize" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="btnSize" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookie from '@/utils/cookie.js'
export default {
  name: 'AddOrUpdate',
  data () {
    return {
      btnSize: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {},
      energyPricingObject: {
        energyType: 1,
        model: 1,
        unitPrice: '',
        ladder: [
          { thresholdValue: '', unitPrice: '' }
        ],
        point: [
          { name: '峰', type: 'peak', }
        ],
        params: ''
      },
      siteList: [],
      siteSelected: [],
      energyPricing: [],
      energyTypes: [
        { label: '电', value: 1 },
        { label: '水', value: 2 },
        { label: '天然气', value: 3 },
        { label: '柴油', value: 4 }
      ]
    }
  },
  computed: {
    dataRule () {
      return {
        takePercentageFromProfit: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        lesseeId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        propertyCompanyId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        lesseeTransactorId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        propertyTransactorId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (rowId) {
      this.visible = true
      let companyId = this.$store.state.user.companyId || 0
      Promise.all([
        // this.$api.rentalArea.getRentalAreaTrusteeshipContractForProperty(companyId).then((res) => {
        //   if (res.success) {
        //     this.siteList = res.data
        //   }
        // })
        this.$tmp.getAreaDataForProperty(companyId).then((res) => {
          this.siteList = res
        })
      ]).then(() => {
        this.$nextTick(() => {
          this.dataForm = {
            lesseeNature: '',
            lesseeId: '',
            lesseeTransactorId: '',
            propertyCompanyId: '',
            propertyTransactorId: '',
            energyPricing: [
              {
                energyType: 1,
                model: 2,
                params: '',
                unitPrice: '',
                ladder: [
                  { thresholdValue: '0', unitPrice: '' }
                ],
                point: [
                  { name: '峰', type: 'peak', time: [{ startTime: '', endTime: '' }], price: '' },
                  { name: '平', type: 'plain', time: [{ startTime: '', endTime: '' }], price: '' },
                  { name: '谷', type: 'valley', time: [{ startTime: '', endTime: '' }], price: '' },
                  { name: '尖', type: 'sharp', time: [{ startTime: '', endTime: '' }], price: '' }
                ]
              }
            ],
            basicCharges: [
              // { name: '', value: '' }
            ],
            takePercentageFromProfit: ''
          }
          this.$refs['dataForm'].resetFields()
          // this.dialogLoading = true
        })
      })
    },
    handleEnergyTypeChange (energyPricing) {
      this.$nextTick(() => {
        if (energyPricing.energyType === 1) {
          energyPricing.model = 2
        } else {
          energyPricing.model = 1
        }
        this.$forceUpdate()
      })
    },
    handleModelChange (energyPricing) {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    handleAddEnergyPricing () {
      this.dataForm.energyPricing.push({
        energyType: 1,
        model: 2,
        params: '',
        ladder: [
          { thresholdValue: '0', unitPrice: '' }
        ],
        point: [
          { name: '峰', type: 'peak', time: [{ startTime: '', endTime: '' }], price: '' },
          { name: '平', type: 'plain', time: [{ startTime: '', endTime: '' }], price: '' },
          { name: '谷', type: 'valley', time: [{ startTime: '', endTime: '' }], price: '' },
          { name: '尖', type: 'sharp', time: [{ startTime: '', endTime: '' }], price: '' }
        ]
      })
      this.$forceUpdate()
    },
    handleAddRow (energyPricing) {
      energyPricing.ladder.push({
        thresholdValue: '0',
        unitPrice: ''
      })
      this.$forceUpdate()
    },
    handleAddTimeRow (point) {
      point.time.push({
        startTime: '',
        endTime: ''
      })
      this.$forceUpdate()
    },
    handleAddBasicCharges () {
      this.dataForm.basicCharges.push({ name: '', value: '' })
      this.$forceUpdate()
    },
    handleSelectionChange (val) {
      this.siteSelected = val.map((item) => {
        return item.id
      })
    },
    submitHandle: debounce(function () {
      console.log(this.dataForm)
      let energyPricingObject = this.dataForm.energyPricing
      for (let i = 0; i < energyPricingObject.length; i++) {
        if (energyPricingObject[i].energyType === 1 && energyPricingObject[i].model === 3) {
          console.log(energyPricingObject[i])
          energyPricingObject[i].params = []
          energyPricingObject[i].params = energyPricingObject[i].ladder
        } else if (energyPricingObject[i].energyType === 1 && energyPricingObject[i].model === 1) {
          let obj = {}
          let unitPrice = {}
          energyPricingObject[i].point.forEach((item) => {
            obj[item.type] = item.time
            unitPrice[item.type] = item.price
          })
          energyPricingObject[i].params = {}
          energyPricingObject[i].params = {
            startTime: 0,
            endTime: 8,
            timeSegment: obj,
            unitPrice: unitPrice
          }
          console.log('332', energyPricingObject[i].params)
        } else {
          energyPricingObject[i].params = {}
          energyPricingObject[i].params = {
            unitPrice: energyPricingObject[i].unitPrice
          }
        }
      }
      console.log(energyPricingObject)
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        console.log(this.dataForm.energyPricingObject)
        this.$api.rentalArea.addLeaseContract(
          this.$moment(this.dataForm.startTime).format('YYYY/MM/DD HH:mm:ss'),
          this.$moment(this.dataForm.endTime).format('YYYY/MM/DD HH:mm:ss'),
          this.dataForm.lesseeNature,
          this.dataForm.lesseeId,
          this.dataForm.lesseeTransactorId,
          0,
          0,
          this.siteSelected,
          energyPricingObject,
          this.dataForm.basicCharges
        ).then((res) => {
          this.dialogLoading = false
          if (res.success) {
            console.log(res)
            this.visible = false
            this.$emit('handleQuery')
          } else {
            this.$message.error(res.errorStr)
          }
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    handleDeleteItem (list, index) {
      list.splice(index, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-simple {
  text-align: left;
  .add-or-update-form {
    max-height: 720px;
    overflow: auto;
  }
  .btn-content {
    margin: 0 0 12px 0;
    text-align: center;
  }
}

.content {
  box-sizing: border-box;
  padding: 0 8px;
}

.border {
  // margin: 12px 0;
  padding: 12px 0;
  border: 1px solid;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  &.energyPricing {
    padding-bottom: 40px;
  }
  .delete {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
}
.sub-title {
  box-sizing: border-box;
  padding-left: 24px;
}

.ladder {
  width: 100%;
  overflow: hidden;
  display: flex;
  .ladder-left {
    width: 120px;
    // border: 1px solid;
    text-align: right;
    box-sizing: border-box;
    padding: 0 8px;
  }
  .ladder-right {
    width: calc(100% - 120px);
    box-sizing: border-box;
    .title-content {
      display: flex;
      border: 1px solid;
      .threshold-value {
        width: 50%;
        text-align: center;
        // border: 1px solid;
        padding: 8px;
        box-sizing: border-box;
      }
      .unit-price {
        width: 50%;
        text-align: center;
        // border: 1px solid;
        padding: 8px;
        box-sizing: border-box;
      }
    }
    .input-content {
      display: flex;
      .threshold-value {
        width: 50%;
        text-align: center;
        border: 1px solid;
        padding: 8px;
        box-sizing: border-box;
      }
      .unit-price {
        width: 50%;
        text-align: center;
        border: 1px solid;
        padding: 8px;
        box-sizing: border-box;
      }
    }
  }
  
}

.point {
  width: 100%;
  overflow: hidden;
  .point-item {
    width: 100%;
    display: flex;
    margin-bottom: 16px;
    padding: 8px;
    box-sizing: border-box;
    // border-bottom: 1px solid;
    .item-left {
      width: 120px;
      // border: 1px solid;
      text-align: right;
      box-sizing: border-box;
      padding: 0 8px;
    }
    .item-right {
      width: calc(100% - 120px);
    }
  }
  .time-content {
    width: 100%;
    display: flex;
    .time-left {
      width: 100px;
      text-align: right;
      padding: 0 8px;
      box-sizing: border-box;
    }
    .time-right {
      // width: calc(100% - 100px);
      border: 1px solid;
    }
    .input-content {
      display: flex;
      .startime {
        width: 50%;
        text-align: center;
        padding: 8px;
        border: 1px solid;
      }
      .endtime {
        width: 50%;
        text-align: center;
        padding: 8px;
        border: 1px solid;
      }
    }
  }
  .table-content {
    display: flex;
    .startime {
      width: 50%;
      text-align: center;
      padding: 8px;
    }
    .endtime {
      width: 50%;
      text-align: center;
      padding: 8px;
    }
  }
}

.add {
  width: 100%;
  height: 40px;
  background: #409EFF;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  &.ladder-add {
    margin-bottom: 12px;
  }
}

.basic-fee {
  margin: 12px 0;
  width: 100%;
  // display: flex;
  overflow: hidden;
  .basic-fee-left {
    width: 110px;
    text-align: left;
    // padding: 8px;
  }
  .basic-fee-right {
    // width: calc(100% - 110px);
    .table-content {
      border: 1px solid;
      display: flex;
      .name, .fee {
        border: none;
      }
    }
    .input-content {
      display: flex;
    }
    .name, .fee, .value {
      width: 50%;
      border: 1px solid;
      text-align: center;
      padding: 8px;
      box-sizing: border-box;
    }
  }
}

</style>
